import React from 'react';
import { Body } from './Body';
import styles from './CreationLayout.module.css';
import { Footer } from './Footer';
import { Header } from './Header';
import { HeaderTitleAlign, TabsAlign } from './Header/Header';
import { useCreationLayout } from './useCreationLayout';

export type CreationLayoutProps = {
  children: React.ReactNode;
};

const CreationLayout = ({ children }: CreationLayoutProps) => {
  return <div className={styles.creationLayoutContainer}>{children}</div>;
};

CreationLayout.Header = Header;
CreationLayout.Footer = Footer;
CreationLayout.Body = Body;
CreationLayout.HeaderTitleAlign = HeaderTitleAlign;
CreationLayout.TabsAlign = TabsAlign;
CreationLayout.useCreationLayout = useCreationLayout;

export default CreationLayout;
